import React, { Fragment, useState, useContext } from "react";
// import "../scss/sb-admin-2.css";
import Sidebar from "../components/Admin/Sidebar/Sidebar";
import Topbar from "../components/Admin/Topbar";
import { FirebaseContext } from "../models/FirebaseContext";
import { AuthContext } from "../models/AuthContext";
// import "../admin/jquery.easing.min.js";
// import "../admin/sb-admin-2.min.js";

const AdminLayout: React.FC = ({ children }) => {
  const firebase = useContext(FirebaseContext);

  const [, , setFlashMessage] = useContext(AuthContext);

  const [isToggled, setToggled] = useState<boolean>(false);

  function sideToogle() {
    setToggled(!isToggled);
  }

  async function logOut() {
    try {
      const res = await firebase.authentication().signOut();
      if (res)
        setFlashMessage({
          show: true,
          msg: "You are signed out",
          style: "bg-primary-light text-primary",
        });
    } catch (e) {
      setFlashMessage({
        show: true,
        msg: "Error signing out",
        style: "bg-danger-light text-danger",
      });
    }
  }

  return (
    <Fragment>
      <div id="wrapper">
        <Sidebar
          isToggled={isToggled}
          toogleHandler={sideToogle}
          signOutHandler={logOut}
        />
        {/* <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          <Topbar toogleHandler={sideToogle} signOutHandler={logOut} />
          {/* <!-- Main Content --> */}
          <div id="content">
            {/* <!-- Topbar --> */}

            {/* <!-- End of Topbar --> */}

            {/* <!-- Begin Page Content --> */}
            <div className="container-fluid">
              {children}
              {/* <!-- Page Heading --> */}
            </div>
            {/* <!-- /.container-fluid --> */}
          </div>
          {/* <!-- End of Main Content --> */}

          {/* <!-- Footer --> */}
          <footer className="sticky-footer bg-white">
            <div className="container my-auto">
              <div className="copyright text-center my-auto">
                <span>Copyright &copy; Your Website 2019</span>
              </div>
            </div>
          </footer>
          {/* <!-- End of Footer --> */}
        </div>
        {/* <!-- End of Content Wrapper --> */}
      </div>
      {/* <!-- End of Page Wrapper --> */}
      {/* <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      {/* <!-- Logout Modal--> */}
    </Fragment>
  );
};

export default AdminLayout;
